import { useState, useRef, useEffect } from 'react';
import * as stylex from '@stylexjs/stylex';
import { ReactComponent as FolderIcon } from './icons/folder.svg';
import { styles } from '../styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const webkitdirectorySupported = ('webkitdirectory' in document.createElement('input'));
const EmptyComp = () => null;
export const Comp = _ref => {
  let {
    label,
    fileExts,
    onFileSelect,
    defaultFiles,
    defaultIndex,
    disabled,
    dark
  } = _ref;
  const [files, setFiles] = useState();
  const [selectedIndex, setSelectedIndex] = useState(0); // file name of an individual upload if it's not a directory mode
  const [fileUploadName, setFileUploadName] = useState();
  const fileInputRef = useRef();
  const directoryInputRef = useRef();
  useEffect(() => {
    if (defaultFiles) {
      setFiles(defaultFiles);
      setSelectedIndex(defaultIndex);
      setFileUploadName(null);
    }
  }, [defaultFiles, defaultIndex]);
  const handleDirectoryChange = e => {
    var _e$target$files;
    if (!((_e$target$files = e.target.files) !== null && _e$target$files !== void 0 && _e$target$files.length)) {
      return;
    }
    const filesArray = [...e.target.files]; // escaping the first symbol given that file extensions start with dot
    const regexedExts = fileExts.map(ext => "(\\".concat(ext, ")")).join('|');
    const fileExtRegex = new RegExp(".*".concat(regexedExts, "$"));
    const filteredFiles = filesArray.filter(_ref2 => {
      let {
        name
      } = _ref2;
      return fileExtRegex.test(name);
    });
    if (!filteredFiles.length) {
      return;
    }
    setFiles(filteredFiles);
    setSelectedIndex(0); // clear hidden file input so the user can select the same file again
    fileInputRef.current.value = null; // it's either directory or a file mode
    setFileUploadName(null);
    onFileSelect(filteredFiles[0]);
  };
  const renderOptions = () => {
    return [...files].map((file, index) => /*#__PURE__*/_jsx("option", {
      onClick: () => onFileSelect(file),
      value: index,
      children: file.name
    }, Math.random()));
  };
  const handleSelectChange = e => {
    const index = e.target.value;
    if (index === "-1") {
      fileInputRef.current.click();
      e.preventDefault();
      return;
    }
    const file = files[index];
    onFileSelect(file);
    setSelectedIndex(index);
  };
  const handleSelectClick = e => {
    if (fileUploadName || !files) {
      fileInputRef.current.click();
      e.preventDefault();
    }
  };
  const handleFileInput = e => {
    var _e$target$files2;
    if (!((_e$target$files2 = e.target.files) !== null && _e$target$files2 !== void 0 && _e$target$files2.length)) {
      return;
    }
    const file = e.target.files[0];
    onFileSelect(file);
    setFileUploadName(file.name);
    setFiles(null);
    directoryInputRef.current.value = null;
  };
  const handleOpenDirectory = () => {
    directoryInputRef.current.click();
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("p", {
      children: label
    }), /*#__PURE__*/_jsxs("div", {
      ...stylex.props(styles.directoryInputWrapper),
      children: [/*#__PURE__*/_jsx(FolderIcon, {
        onClick: handleOpenDirectory,
        ...stylex.props(styles.directoryButton, dark && styles.directoryButtonDarkMode)
      }), /*#__PURE__*/_jsxs("select", {
        value: selectedIndex,
        onChange: handleSelectChange,
        onClick: handleSelectClick,
        disabled: disabled,
        onMouseDown: e => {
          !files && e.preventDefault();
        },
        ...stylex.props(styles.directoryFileSelect, !files && styles.selectWithoutExpander, disabled && styles.directoryFileSelectDisabled, dark && styles.directoryFileSelectDarkMode),
        children: [/*#__PURE__*/_jsx("option", {
          value: "-1",
          children: fileUploadName || 'Choose file'
        }), files && renderOptions()]
      }), /*#__PURE__*/_jsx("input", {
        type: "file",
        webkitdirectory: "true",
        onChange: handleDirectoryChange,
        disabled: disabled,
        ref: directoryInputRef,
        ...stylex.props(styles.directoryHiddenInput)
      }), /*#__PURE__*/_jsx("input", {
        type: "file",
        accept: fileExts.join(','),
        onChange: handleFileInput,
        ref: fileInputRef,
        ...stylex.props(styles.directoryHiddenInput)
      })]
    })]
  });
};
export const DirectorySelect = webkitdirectorySupported ? Comp : EmptyComp;